/**

 ▬▬ι═══════ﺤ            -═══════ι▬▬
 Created by Chris on 21/07/17.
 ▬▬ι═══════ﺤ            -═══════ι▬▬

 **/

import fetchJSON from "./fetchJSON";

export default function post(url, token, data) {
    return fetchJSON("post", url, token, data);
}
